export const INITIALIZE_RECEIPT = 'initialize-receipt';
const initializeReceipt = ({ selectedParkingPassIds }) => ({
  type: INITIALIZE_RECEIPT,
  payload: { selectedParkingPassIds },
});
export default initializeReceipt;
